import { DateTime } from 'luxon'
import * as React from 'react'

// Constants
import { BALANCE_LIMIT_TYPE, DOWNLOAD_TYPE } from '../../../constants'

// Helpers
import { prepareUrl } from 'helpers/strings'

// Modules
import { DI } from 'modules'

const DSAPassLimitLeft = ({ agreement, common }) => {
  const { auto_renewal, expires_at, url_1, url_2 } = agreement
  const { quota } = agreement.balance
  const { limit_type, quota: userQuota } = agreement.user_balance

  const { strings } = common

  const buyPlanCln = 'side-buy-plan'
  const prefix = 'page.video.slider.pass'

  return (
    <>
      <div className={`${buyPlanCln}__text`}>
        {limit_type === BALANCE_LIMIT_TYPE.POOL && (userQuota || quota)}
        {strings[`${prefix}.${limit_type}.info.normal`]}
      </div>

      <div className={`${buyPlanCln}__info`}>
        <span>{strings[`${prefix}.additions`]}</span>

        {[url_1, url_2].filter(Boolean).map((url, index) => (
          <span key={index}>
            <a href={prepareUrl(url)} rel="noopener noreferrer" target="_blank">
              {url}
            </a>
          </span>
        ))}

        {!auto_renewal && (
          <span>
            {strings[`${prefix}.valid_till`]}
            {DateTime.fromISO(expires_at)
              .toUTC()
              .toFormat(strings['page.video.slider.date.format'])}
          </span>
        )}
      </div>
    </>
  )
}

export default DI(['common'])(DSAPassLimitLeft)
